import { CalendarIcon, ChatBubbleLeftRightIcon, Cog6ToothIcon, Cog8ToothIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useNavigate } from "react-router-dom";

import { Headline, Paragraph } from "@fronterahealth/frontera-ui-components";

interface NavigationTile {
  title: string;
  description: string;
  path: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

const navigationTiles: NavigationTile[] = [
  {
    title: "Expert Chat",
    description: "View and manage your patient conversations",
    path: "/frontera-clarity/expert-chat",
    Icon: ChatBubbleLeftRightIcon,
  },
  {
    title: "Billing",
    description: "Manage billing and invoicing",
    path: "/frontera-clarity/billing",
    Icon: Cog6ToothIcon,
  },
  {
    title: "Scheduling",
    description: "Schedule and manage appointments",
    path: "/frontera-clarity/scheduling",
    Icon: Cog8ToothIcon,
  },
  {
    title: "My Availability",
    description: "Set and update your availability",
    path: "/frontera-clarity/my-availability",
    Icon: CalendarIcon,
  },
];

export const FronteraClarity: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="mb-8">
        <Headline size="medium">Frontera Clarity</Headline>
        <Paragraph colorType="secondary" className="mt-2">
          Select a section to get started
        </Paragraph>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {navigationTiles.map((tile) => {
          const Icon = tile.Icon;
          return (
            <div
              key={tile.path}
              onClick={() => navigate(tile.path)}
              className="bg-white rounded-lg border-2 border-limestone-200 p-6 cursor-pointer transition-all hover:border-rio-500 hover:shadow-lg group"
            >
              <div className="flex flex-col items-center text-center space-y-4">
                <div className="p-4 bg-limestone-50 rounded-full group-hover:bg-rio-50 transition-colors">
                  <Icon className="h-8 w-8 text-limestone-600 group-hover:text-rio-600 transition-colors" />
                </div>
                <div>
                  <Paragraph displayType="loud" colorType="primary" className="mb-2">
                    {tile.title}
                  </Paragraph>
                  <Paragraph colorType="secondary" className="text-sm">
                    {tile.description}
                  </Paragraph>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
